export type InsiderTermsAndConditionsStatusType =
  | 'INSIDER_TERMS_AND_CONDITIONS_STATUS_UNKNOWN'
  | 'PENDING'
  | 'ACCEPTED'
  | 'OUTDATED';

export enum InsiderTermsAndConditionsStatus {
  INSIDER_TERMS_AND_CONDITIONS_STATUS_UNKNOWN = 'INSIDER_TERMS_AND_CONDITIONS_STATUS_UNKNOWN',
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  OUTDATED = 'OUTDATED',
}
